module.exports = __webpack_public_path__ + "images/imagelogo.44e269f8.png";